export function getLoremIpsum(length = 4000): string {
  const value = `2-27-25:
Incident Information
Department Where Injury Occurred
Feather side
Time Employee Began Work
06:00 AM
Employer Notified Date
Thursday, February 27, 2025
Activity Engaged In
Walking through feather side and slipped and fell to right knee
Injury Work Process
Loss Description
Fell to right knee and jarred right hip`;

  const count = Math.random() * value.length;
  return value.substring(0, count);
}
